import { priorityTypes } from '../../constants/shit-priority-types'
import { viewTypes } from '../../constants/shit-view-types'
import { doneTypes } from '../../constants/shit-done-types'
import { scheduleTypes } from '../../constants/shit-schedule-types'

export default {
  namespaced: true,
  state: {
    searchString: null,
    selectedSchedule: scheduleTypes.SCHEDULE_ANY,
    selectedContexts: [],
    selectedProjects: [],
    selectedMentions: [], // @todo rename to mentions
    selectedActions: ['any'],
    selectedDoneType: doneTypes.DONE_TODAY,
    selectedOrder: 'new shit last',
    selectedPriority: priorityTypes.SHIT_PRIORITY_ANY,
    view: viewTypes.VIEW_DEFAULT
  },
  getters: {
    view (state) {
      return state.view
    }
  },
  mutations: {
    reset (state) {
      state.searchString = null
      state.selectedSchedule = scheduleTypes.SCHEDULE_ANY
      state.selectedContexts = []
      state.selectedProjects = []
      state.selectedMentions = [] // @todo rename to mentions
      state.selectedActions = ['any']
      state.selectedDoneType = doneTypes.DONE_TODAY
      state.selectedOrder = 'new shit last'
      state.selectedPriority = priorityTypes.SHIT_PRIORITY_ANY
      state.view = viewTypes.VIEW_DEFAULT
    },
    setView (state, value) {
      state.view = value
    },
    setSearchString (state, value) {
      state.searchString = value
    },
    setSelectedSchedule (state, value) {
      state.selectedSchedule = value
    },
    setSelectedContexts (state, value) {
      state.selectedContexts = value
    },
    setSelectedProjects (state, value) {
      state.selectedProjects = value
    },
    setSelectedMentions (state, value) {
      state.selectedMentions = value
    },
    setSelectedActions (state, value) {
      state.selectedActions = value
    },
    setSelectedDoneType (state, value) {
      state.selectedDoneType = value
    },
    setSelectedOrder (state, value) {
      state.selectedOrder = value
    },
    setSelectedPriority (state, value) {
      state.selectedPriority = value
    }
  },
  actions: {
  }
}
